// 입시 용어집 v1 — 한 줄 정의, 합격선 숫자 없음
export const glossaryMeta = {
  title: '입시 용어집',
  lede:
    '모집요항·공식 안내에서 자주 나오는 용어를 짧게 풀어 둡니다. 정의보다 해당 연도 원문 표기가 우선입니다.',
  updatedAt: '2026-07',
};

export const glossaryTerms = [
  {
    id: 'yokoan',
    ja: '募集要項',
    ko: '모집요항(요강)',
    def: '대학이 연도·전형별로 내는 지원 자격·시험·서류·일정의 공식 안내서(대개 PDF).',
    guideIds: ['yokoan-howto'],
  },
  {
    id: 'shigan',
    ja: '出願資格',
    ko: '출원자격',
    def: '지원할 수 있는 학력·연령·국적·재류 등 조건. 충족 여부는 요강 문구로만 판단.',
    guideIds: ['yokoan-howto'],
  },
  {
    id: 'kenetei',
    ja: '検定料',
    ko: '검정료',
    def: '원서 접수 시 내는 전형료. 금액·납부 방법(카드·송금 등)은 요강에 명시.',
    guideIds: ['yokoan-howto'],
  },
  {
    id: 'shutsu-gengo',
    ja: '出題言語',
    ko: '출제 언어',
    def: 'EJU 등에서 문제 언어(일본어/영어 등). 학부가 지정·선택 가능한지 요강 확인.',
    guideIds: ['eju-2026-syllabus', 'yokoan-howto'],
  },
  {
    id: 'shitei-kai',
    ja: '指定回',
    ko: '지정 회(차)',
    def: '인정하는 EJU 실시 회차(예: 6월·11월). 요강에 적힌 회차만 유효한 경우가 많음.',
    guideIds: ['yokoan-howto', 'eju-vs-general'],
  },
  {
    id: 'hicchaku',
    ja: '必着',
    ko: '필착',
    def: '서류가 마감일까지 대학에 도착해야 함(발송일 기준이 아님). 해외 우편 시 여유 필요.',
    guideIds: ['yokoan-howto'],
  },
  {
    id: 'tonichimae',
    ja: '渡日前入学許可',
    ko: '도일 전 입학허가',
    def: '해외에 있으면서 선발·입학 허가까지 진행하는 형태. EJU 이용 학교 목록은 JASSO 참고.',
    guideIds: ['prearrival-scholarship'],
  },
  {
    id: 'eju',
    ja: '日本留学試験 (EJU)',
    ko: '일본유학시험',
    def: 'JASSO 주관. 유학생 학부 전형에서 일본어·기초학력 성적으로 자주 사용.',
    guideIds: ['eju-vs-general', 'eju-2026-syllabus'],
  },
  {
    id: 'kyotsu',
    ja: '大学入学共通テスト',
    ko: '대학입학공통테스트',
    def: '일반선발의 공통 시험. DNC가 실시. 외국인 일반선발에서도 요구될 수 있음.',
    guideIds: ['eju-vs-general'],
  },
  {
    id: 'honsiken',
    ja: '個別学力検査 / 本試験',
    ko: '개별학력검사·본고사',
    def: '대학이 자체 실시하는 2차 필기·실기 등. 과목은 학부 요강이 기준.',
    guideIds: ['eju-vs-general', 'science-medicine-path'],
  },
  {
    id: 'ippan',
    ja: '一般選抜',
    ko: '일반선발',
    def: '주로 일본 고교 과정 전제의 전형. 공통테스트·본고사 조합이 흔함.',
    guideIds: ['eju-vs-general'],
  },
  {
    id: 'ryugakusei',
    ja: '私費外国人留学生入試',
    ko: '사비 외국인 유학생 전형',
    def: '유학생을 대상으로 한 특별전형의 통칭. EJU·서류·면접 등을 조합하는 경우가 많음.',
    guideIds: ['eju-vs-general'],
  },
  {
    id: 'shoreihi',
    ja: '学習奨励費',
    ko: '학습장려비',
    def: '사비 유학생 대상 장학·지원의 한 형태. 예약·사전입학 연계 등은 JASSO 안내 확인.',
    guideIds: ['prearrival-scholarship'],
  },
  {
    id: 'mext',
    ja: '文部科学省国費留学生',
    ko: '국비유학생(MEXT)',
    def: '문부과학성 장학금 유학생. 학부는 대사관 추천·대학 추천 등으로 나뉨.',
    guideIds: ['mext-scholarship'],
  },
  {
    id: 'syllabus',
    ja: 'シラバス（出題範囲）',
    ko: '시라버스(출제 범위)',
    def: 'EJU 기초학력 등 시험의 출제 범위 문서. 2026년도 제1회부터 개정판 적용.',
    guideIds: ['eju-2026-syllabus'],
  },
  {
    id: 'course-math',
    ja: '数学コース1 / コース2',
    ko: '수학 코스1·코스2',
    def: 'EJU 수학 난이도·범위 구분. 학부가 어느 코스를 지정하는지 요강 확인.',
    guideIds: ['eju-2026-syllabus', 'science-medicine-path'],
  },
  {
    id: 'sogo',
    ja: '総合科目',
    ko: '종합과목',
    def: 'EJU 문과 계열에서 자주 쓰는 기초학력 과목(정치·경제·지리·역사 등 횡단).',
    guideIds: ['eju-2026-syllabus'],
  },
  {
    id: 'rika',
    ja: '理科',
    ko: '이과',
    def: 'EJU 물리·화학·생물. 학부가 지정한 과목 조합을 응시.',
    guideIds: ['science-medicine-path', 'eju-2026-syllabus'],
  },
  {
    id: 'english-ext',
    ja: '英語外部試験',
    ko: '영어 외부시험',
    def: 'TOEFL·IELTS·TOEIC 등. 최저·유효기간·직송 여부는 요강 표가 기준.',
    guideIds: ['english-in-yokoan'],
  },
  {
    id: 'ao',
    ja: '総合型選抜 / AO',
    ko: '종합형 선발·AO',
    def: '서류·면접·활동 등을 종합하는 전형. 대학·학부마다 명칭·평가가 다름.',
    guideIds: ['yokoan-howto'],
  },
];
